import { ResolveFn } from '@angular/router';
import { jwtDecode } from 'jwt-decode';
import { inject } from '@angular/core';
import { catchError, map, of } from 'rxjs';
import { CompanyService } from '../../services/company.service';
import { environment } from '../../../app/environments/enviroment';

export const workspaceResolver: ResolveFn<any> = () => {
  const token = localStorage.getItem('token') || localStorage.getItem('token-otp');

  if (!token) {
    console.error('[workspaceResolver] No token found.');
    return of({
      allowedCompanies: [],
      restrictedCompanies: []
    });
  }

  let decodedToken: any;
  try {
    decodedToken = jwtDecode(token);
  } catch (error) {
    console.error('[workspaceResolver] Error decoding token:', error);
    return of({
      allowedCompanies: [],
      restrictedCompanies: []
    });
  }

  const userId = decodedToken?.sub?.id;
  if (!userId) {
    console.error('[workspaceResolver] UserId (id) not found in token.');
    return of({
      allowedCompanies: [],
      restrictedCompanies: []
    });
  }

  const companyService = inject(CompanyService);

  return companyService.getCompaniesByUserId(String(userId), environment.platformNameOrchGT).pipe(
    map(result => {
      const data = result.data as { findAllByUserIdAndPlatformName: any };
      const rawSelection = data?.findAllByUserIdAndPlatformName;

      if (Array.isArray(rawSelection)) {
        return {
          allowedCompanies: rawSelection,
          restrictedCompanies: []
        };
      }

      return {
        allowedCompanies: rawSelection?.allowedCompanies ?? [],
        restrictedCompanies: rawSelection?.restrictedCompanies ?? []
      };
    }),
    catchError(err => {
      console.error('[workspaceResolver] Error fetching companies:', err);
      return of({
        allowedCompanies: [],
        restrictedCompanies: []
      });
    })
  );
};
